import { useEffect, useMemo, useState } from "react";
import Pagination from "../../../components/common/Pagination";

const DEFAULT_PAGE_SIZE = 10;

/**
 * Phân trang client cho bảng báo cáo.
 * Chỉ nên render Pagination khi total > 10.
 */
export function useReportTablePage(rows = [], resetKey) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const list = rows || [];
  const total = list.length;

  useEffect(() => {
    setCurrentPage(1);
  }, [resetKey, total, pageSize]);

  const pageRows = useMemo(() => {
    if (total <= DEFAULT_PAGE_SIZE && pageSize === DEFAULT_PAGE_SIZE) {
      return list;
    }
    const start = (currentPage - 1) * pageSize;
    return list.slice(start, start + pageSize);
  }, [list, total, currentPage, pageSize]);

  const showPagination = total > DEFAULT_PAGE_SIZE;

  return {
    pageRows,
    total,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    showPagination,
  };
}

export function ReportTablePagination({
  total,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  show,
}) {
  if (!show || total <= 10) return null;
  return (
    <div className="mt-3 px-1">
      <Pagination
        totalRecords={total}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onPageSizeChange={(size) => {
          onPageSizeChange(size);
          onPageChange(1);
        }}
      />
    </div>
  );
}
